import { render, staticRenderFns } from "./NavlessLayout.vue?vue&type=template&id=085b0a08&scoped=true&"
import script from "./NavlessLayout.vue?vue&type=script&lang=js&"
export * from "./NavlessLayout.vue?vue&type=script&lang=js&"
import style0 from "./NavlessLayout.vue?vue&type=style&index=0&id=085b0a08&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085b0a08",
  null
  
)

export default component.exports